import { jsx as _jsx } from "react/jsx-runtime";
import Link from '@rad/components/utility/link';
import { districtUrls } from '../../../../common/routes/urls/district';
import { previewUrl } from '../../../../hooks/useTourPreview';
// The tour page's Know before you go section, which Info opens on.
export const TOUR_INFO_ID = 'tour-info';
// The tour's own tab bar, fixed to the foot of the screen.
const TourTabs = (props) => {
    const tourUrl = previewUrl(districtUrls.toursDetail.getURL({ id: props.tourId }), props.previewing);
    const tabs = [
        { id: 'tour', label: 'Tour', href: tourUrl },
        { id: 'map', label: 'Map', href: previewUrl(districtUrls.toursMap.getURL({ id: props.tourId }), props.previewing) },
        { id: 'info', label: 'Info', href: `${tourUrl}#${TOUR_INFO_ID}` },
    ];
    return (_jsx("nav", { className: "tour-tabs", "aria-label": "Tour", children: tabs.map(tab => (_jsx(Link, { href: tab.href, className: `tour-tab ${tab.id === props.active ? 'tour-tab--active' : ''}`, "aria-current": tab.id === props.active ? 'page' : undefined, children: tab.label }, tab.id))) }));
};
export default TourTabs;
